module.exports = __webpack_public_path__ + "img/rubin_benefit_16_kitchen.89036eb0.svg";